/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */
import Fraction from 'fraction.js'
import fractionUnicode from 'fraction-unicode'
import _, {
  find,
  get,
  isEmpty,
  isUndefined,
  isNull,
  mapValues,
  size,
  map,
  mapKeys,
  startsWith,
  endsWith,
  snakeCase,
  lowerCase,
  startCase,
  camelCase,
  values,
  includes,
  cloneDeep,
} from 'lodash'
import { queryClient } from '@/config/react-query'
import HttpRequest from '@/config/axios.config'
import { quantity_breakdown_types_obj } from '@/screens/Order/constant/quanity_breakdown'
import moment, { Moment } from 'moment'
import {
  INSPECTION_TEXT,
  INSPECTION_TYPE_SUBMIT_FOR_REVIEW,
} from '@/screens/QSF/Inspection/Inspection.constant'
import { IsAdminRole } from './users'

export function isObject(objValue: Object) {
  return (
    objValue && typeof objValue === 'object' && objValue.constructor === Object
  )
}

function sortObject(object: any) {
  var sortedObject: any = {}
  _(object)
    .keys()
    .sort()
    .each(function (key: any) {
      if (isObject(object[`${key}`])) {
        sortObject(object[`${key}`])
      }
      sortedObject[`${key}`] = object[`${key}`]
    })
  return sortedObject
}

export function JSONStringify(object: any) {
  if (isEmptyValue(object)) return ''
  return JSON.stringify(sortObject(object))
}

export function IsJsonString(str: string) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export function toJsonObject(data: any) {
  for (let [key, value] of Object.entries(data) as any) {
    if (IsJsonString(value)) {
      data[`${key}`] = JSON.parse(value)
    }
  }
  return data
}
export function jsonObjectToNull(data: any) {
  for (let [key, value] of Object.entries(data) as any) {
    if (isUndefined(value)) {
      data[`${key}`] = null
    }
  }
  return data
}

export function toJson(data: any) {
  if (isEmpty(data)) return []
  return isObject(data) ? data : JSON.parse(data)
}

export function formatColumn(values: string) {
  return values.replace(/([A-Z])/g, ' $1')
}

export function Capitalize(values: string) {
  return values
    ?.replace(/[^A-Z0-9]/gi, ' ')
    ?.replace(/\b\w/g, (l) => l?.toUpperCase())
}

export function pad(d: number) {
  return d < 10 ? '0' + d.toString() : d.toString()
}

export function formatLabel(text: string) {
  const result = text?.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}

export function camelToSnakeCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function OrdinalSuffix(i) {
  var j = i % 10,
    k = i % 100
  if (j == 1 && k != 11) {
    return i + 'st'
  }
  if (j == 2 && k != 12) {
    return i + 'nd'
  }
  if (j == 3 && k != 13) {
    return i + 'rd'
  }
  return i + 'th'
}

export function filerInspectionType(data: Array<any>, key) {
  const item = data?.find((item) => item?.key == key)
  return item?.name
}

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/
  return re.test(email)
}

export function numberWithCommas(x) {
  return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function convertDecimalToFraction(n: number) {
  if (!n) {
    return '-'
  }

  const truncated = Math.trunc(n)
  const num = n - truncated
  const fraction = new Fraction(num)
  let fractionText = ''

  if (fraction.n && fraction.d) {
    fractionText = fractionUnicode(fraction.n, fraction.d)
  }

  if (
    (truncated == 0 && fractionText == '') ||
    (fractionText == '' && Number.isNaN(truncated))
  ) {
    return 0
  }
  return `${
    truncated == 0 || Number.isNaN(truncated) ? '' : truncated
  }${fractionText}`
}

export function checkMeasurementSpecOutOfTolerance(
  value: any,
  spec: any,
  plus_tolerance: any,
  minus_tolerance: any
) {
  const newValue = sanitizeNumber(value)
  const newSpec = sanitizeNumber(spec)
  const newPlusTolerance = sanitizeNumber(plus_tolerance)
  const newMinusTolerance = sanitizeNumber(minus_tolerance)
  const isOutOfTolerance =
    parseFloat(newValue) > parseFloat(newSpec) + parseFloat(newPlusTolerance) ||
    parseFloat(newValue) < parseFloat(newSpec) - parseFloat(newMinusTolerance)
  return isOutOfTolerance
}

export function sanitizeNumber(value: any) {
  return String(value).replace(',', '.')
}

export function displayOutOfTolValue(tmpVal: any, tmpSpec: any, unit) {
  const value = sanitizeNumber(tmpVal)
  const spec = sanitizeNumber(tmpSpec)

  if (isEmptyValue(value)) {
    return ''
  }
  if (parseFloat(value) == parseFloat(spec)) {
    return '-'
  } else {
    const data = parseFloat(value) - parseFloat(spec)
    if (data > 0) {
      return `+${
        unit == 'in'
          ? convertDecimalToFraction(data)
          : !Number.isNaN(data)
          ? data.toFixed(1)
          : ''
      }`
    } else {
      return unit == 'in'
        ? '-' + convertDecimalToFraction(data)
        : !Number.isNaN(data)
        ? data.toFixed(1)
        : ''
    }
  }
}

export const onComment = (payload) => {
  queryClient.setQueryData('commentQuery', (old: any) => {
    const oldData = old.data.data
    const { type } = payload
    if (type === 'new') {
      old.data.data = [...oldData, payload]
    } else if (type === 'reply') {
      const {
        parent: { id: parentId },
      } = payload
      const parent = find(oldData, { id: parentId })
      if (parent) {
        parent.children = [...(get(parent, 'children') || []), payload]
      }
    }
    return old
  })
}

export function getUrlParams(key: string) {
  const queryParams = new URLSearchParams(window.location.search)
  return queryParams.get(key)
}
export function setUrlParams(key: string, value: string) {
  const queryParams = new URLSearchParams(window.location.search)
  queryParams.set(key, value)
  return queryParams
}

export function removeUrlParams(key: string) {
  const queryParams = new URLSearchParams(window.location.search)
  queryParams.delete(key)
  return queryParams
}

export async function convertImageToBase64(imgUrl) {
  const data = await HttpRequest.get('medias/clone', {
    params: { url: imgUrl },
  })
  return data?.data?.data
}

// Noted: Sort fields by display_order before render to make sure the order of fields is correct when create.
export const lastDisplayOrder = (data) => {
  if (isEmptyValue(data)) return 1
  const cloneData = cloneDeep(data)
  const pickLastItem = cloneData?.sort(
    (a, b) => b?.display_order - a?.display_order
  )

  return pickLastItem[0].display_order + 1 || cloneData.length
}

export function isEmptyValue(value: any): boolean {
  if (value === null || value === undefined) {
    return true
  } else if (typeof value === 'string' && value.trim().length === 0) {
    return true
  } else if (typeof value === 'number' && isNaN(value)) {
    return true
  } else if (Array.isArray(value) && value.length === 0) {
    return true
  } else if (typeof value === 'object' && value instanceof Date) {
    return isNaN(value.getTime())
  } else if (typeof value === 'object' && Object.keys(value).length === 0) {
    return true
  } else {
    return false
  }
}

export function parseJSON(jsonString) {
  try {
    var o = JSON.parse(jsonString)
    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) {}
  return {}
}

export function titleCase(str) {
  if (!str) return '' // return empty string if input is falsy

  if (str.includes('_')) {
    return str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function calculateTotalOrderQty(data: any) {
  let tmpTotalOrder = 0
  if (
    data?.product_details?.quantity_breakdown?.value ==
    quantity_breakdown_types_obj.TOTAL_QUANTITY_ONLY
  ) {
    return data?.product_details?.order_quantity?.value
  } else if (
    data?.product_details?.quantity_breakdown?.value ==
    quantity_breakdown_types_obj.BY_DESTINATION
  ) {
    for (let [, value] of Object.entries(
      data?.product_details?.order_quantity?.value
    ) as any) {
      tmpTotalOrder = tmpTotalOrder + Number(value?.quantity)
    }
  } else {
    if (!isEmptyValue(data?.product_details?.order_quantity?.value)) {
      for (let [, value] of Object.entries(
        data?.product_details?.order_quantity?.value
      )) {
        for (let [, newValue] of Object.entries(value)) {
          tmpTotalOrder = tmpTotalOrder + Number(newValue)
        }
      }
    }
  }
  return tmpTotalOrder
}

export function thousandSeparator(num = '') {
  let result = num
  if (!isNull(num)) {
    result = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return result
}

/**
 * @param dataSet => { a: [], b: 'a', c: null, d: '', e: {} };
 * @returns => { a: null, b: 'a', c: null, d: null, e: null };
 */
export function transformFieldEmptyToNull(dataSet: any) {
  const result = mapValues(dataSet, (val) => {
    return size(val) ? val : null
  })
  return result
}

/**
 * @param dataSet => { a: [], b: 'a', c: null, d: '', e: {} };
 * @returns => { a: [], b: 'a', c: [], d: [], e: [] };
 */
export function transformFieldEmptyToArray(dataSet: any) {
  const result = mapValues(dataSet, (val) => {
    return size(val) ? val : []
  })
  return result
}

/**
 *
 * @param dataDates => ['2025-03-20','2025-03-20']
 * @returns => [Moment, Moment] | null
 */

export const transformFromUrlQueryToDateRange = (
  dataDates: [string, string]
): [Moment, Moment] | [] => {
  const dates: any =
    map(dataDates, (dateStr) => moment(dateStr, INSPECTION_TEXT.dateFomat)) ||
    null
  return dates
}

export const dateRangConverter = (filterValues: any) => {
  let result = []
  if (size(filterValues)) {
    const dates = filterValues.map((value) =>
      moment(value).format(INSPECTION_TEXT.dateFomat)
    )
    const momentDates = transformFromUrlQueryToDateRange(dates)
    result = [dates, momentDates]
  }
  return result
}

/**
 *
 * @param columnEnum { factory_name = 'factory.name',...}
 * @param sort '-order.number'
 * @param key 'order.number'
 * @returns 'descend'
 */
export const handleTableDefaultSortColumns = <T extends Record<string, string>>(
  columnEnum: T,
  sort: string,
  key: T[keyof T]
): 'ascend' | 'descend' => {
  const sortColumn = values(columnEnum)
  let result = null
  if (!includes(sortColumn, key) && !sort) result = null

  if (startsWith(sort, '-') && sort.slice(1) === key) return 'descend'

  if (sort === key) return 'ascend'

  return result
}

/**
 *
 * @param orgDataSource  - Original string like country_side
 * @param options - {prefix?: string, suffix?: string, type: 'camelCase' | 'snakeCase'}
 * @returns composed string with transformations
 *
 * @usage transformObjComposeKey('country_side', { type: 'camelCase' }) => countrySide
 * @usage transformObjComposeKey('country_side', { type: 'camelCase', prefix: 'prefix' }) => defaultCountrySide
 * @usage transformObjComposeKey('country_side', { type: 'camelCase', suffix: 'suffix' }) => CountrySidesuffix
 *
 * @usage transformObjComposeKey('CountrySidesuffix', { type: 'snakeCase', suffix: 'suffix' }) => country_side
 * @usage transformObjComposeKey('defaultCountrySide', { type: 'snakeCase', prefix: 'default' }) => country_side
 */
export const transformObjComposeKey = (
  orgDataSource,
  options: {
    type: 'camelCase' | 'snakeCase'
    prefix?: string
    suffix?: string
  }
) => {
  const { prefix = '', suffix = '', type = '' } = options

  return mapKeys(
    mapValues(orgDataSource, (value) => {
      return size(value) ? value : []
    }),
    (value, key) => {
      if (type === 'snakeCase') {
        let getKey = key
        if (startsWith(getKey, prefix) && size(prefix)) {
          getKey = getKey.slice(prefix.length)
        }

        if (endsWith(getKey, suffix) && size(suffix)) {
          getKey = getKey.slice(0, -suffix.length)
        }

        const toSnakeCase = snakeCase(getKey)

        return `${toSnakeCase}`
      }
      if (type === 'camelCase') {
        const toToLower = lowerCase(key)
        const toStartCase = size(prefix)
          ? startCase(toToLower).replace(/ /g, '')
          : camelCase(toToLower).replace(/ /g, '')

        return `${prefix}${toStartCase}${suffix}`
      }
    }
  )
}

// Handle other filters dynamically
export const handleAdvanceFilterQueryParams = (dataFilters, options: any) => {
  const { queriesAccepted = [], navigate } = options

  const removeParams = (keys) => {
    const searchParams = new URLSearchParams(window.location.search)
    keys.forEach((key) => {
      searchParams.delete(key)
    })
    navigate({ search: searchParams.toString() })
  }

  Object.entries(dataFilters).forEach(([key, value]: any) => {
    if (value && queriesAccepted.includes(key)) {
      const setUrl = setUrlParams(key, `${value}`)
      navigate({ search: `?${setUrl}` })
    } else {
      // Remove the query params if null
      removeParams([key])
    }
  })
}

export const inviteReviewerPermissionFN = (user: any, record: any) => {
  const isAdmin = IsAdminRole(user)

  if (isAdmin) return isAdmin

  const companyReviewer = get(record, 'company.reviewers')
  const inspectionType = includes(
    [INSPECTION_TYPE_SUBMIT_FOR_REVIEW],
    get(record, 'type')
  )
  const { id } = user
  const hasInTheList = find(companyReviewer, (item) => item.user.id === id)

  return !!size(hasInTheList) && inspectionType
}

export const toJSON = (value: any) => {
  try {
    if (typeof value !== 'string' || !value.trim()) return value
    return JSON.parse(value)
  } catch (_) {
    return value
  }
}
/**
 *
 * @param value 0
 * @param padding 4
 * @returns [1,'0001']
 */
export function padNumber(value: number, padding = 4): [number, string] {
  const numValue = Number(value ?? 0) + 1
  const stringValue = String(numValue).padStart(padding, '0')

  return [numValue, stringValue]
}

export const hiddenOrderPropertiesFN = (hideProperties: any, key = '') => {
  // Guard against undefined or null hideProperties
  if (!size(hideProperties)) {
    return false
  }

  const { value = [] } = hideProperties

  const result = includes(value, key)

  return result
}

/**
 * Converts specific keys of an object to camelCase.
 *
 * @param payload - The original object whose keys may need conversion.
 * @param keysToConvert - An array of keys (in camelCase format) that should be converted.
 * @returns A new object with specified keys converted to camelCase; all other keys remain unchanged.
 *
 * Example:
 * const payload = { finish_fabric_color: "red", page_number: 1 };
 * const keysToConvert = ["finishFabricColor"];
 * const result = convertKeysToCamelCase(payload, keysToConvert);
 * // result => { finishFabricColor: "red", page_number: 1 }
 */
export const convertKeysToCamelCase = (payload, keysToConvert: string[]) => {
  const result = mapKeys(payload, (value, key) =>
    includes(keysToConvert, camelCase(key)) ? camelCase(key) : key
  )

  return result
}

/**
 * removes a simple list-style prefix from the beginning of a string.
 * @param text "1[11]. Apple" | "A[AA]. Apple" | "a[aa]. Apple" | "Apple"
 * @returns "Apple"
 */
export const removeListPrefix = (text: string) => {
  return text.replace(/^\s*[0-9a-zA-Z]+\.\s*/, '')
}

/**
 * Converts a value to a number. If the value cannot be converted, it returns NaN.
 * @param value // '1' | 1 | 'A' | null | undefined | any
 * @returns // 1 | NaN
 */
export const convertToNumber = (value: any) => Number(value)

/**
 * Replaces placeholders in a template string with values from a params object.
 * @param template "Hello {{name}}!"
 * @param params { name: "World" }
 * @returns "Hello World!"
 */
export function interpolate(
  template: string,
  params: Record<string, string | number>
) {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    String(params[key] ?? '')
  )
}

/**
 * Normalises a number field's typed value to a canonical "." decimal.
 *
 * iOS keyboards in comma-decimal locales (most of Europe, Latin America, ...)
 * only expose a comma on the number pad, so a decimal like "55,5" reaches the
 * field with a comma. AntD InputNumber only understands "." as the decimal
 * point, so by default the comma is stripped on blur and "55,5" collapses to
 * "555". Use this as the InputNumber `parser` so both "," and "." are accepted
 * and the value is parsed (and stored) as 55.5.
 * @param displayValue "55,5" | "55.5" | "-12,75" | "" | undefined
 * @returns "55.5" | "55.5" | "-12.75" | "" | ""
 */
export function parseDecimalInput(displayValue?: string): string {
  if (!displayValue) return ''
  return displayValue
    .replace(/,/g, '.') // treat the European decimal comma as a decimal point
    .replace(/[^\d.-]/g, '') // drop anything that is not a digit, dot or sign
}

/**
 * The decimal separator to *display* for the viewer's locale — not tied to any
 * single region: comma-decimal locales see "55,5" while dot-decimal locales see
 * "55.5". The value itself is always stored as a canonical "." number, so this
 * only affects presentation. Use as the InputNumber `decimalSeparator`. Falls
 * back to "." when the locale can't be resolved.
 * @param locale optional BCP 47 locale; defaults to the runtime locale
 * @returns "," | "."
 */
export function getLocaleDecimalSeparator(locale?: string): string {
  try {
    const decimalPart = new Intl.NumberFormat(locale)
      .formatToParts(1.1)
      .find((part) => part.type === 'decimal')
    return decimalPart?.value ?? '.'
  } catch {
    return '.'
  }
}

/**
 * Splits a comma-separated text string, trims whitespace, removes empty values,
 * and deduplicates items case-insensitively.
 */
export function parseCommaSeparatedOptions(input: string): string[] {
  if (!input || typeof input !== 'string') return []
  const seen = new Set<string>()
  return input
    .split(',')
    .map((s) => s.trim())
    .filter((s) => {
      if (!s) return false
      const lower = s.toLowerCase()
      if (seen.has(lower)) return false
      seen.add(lower)
      return true
    })
}
